module.exports = __webpack_public_path__ + "img/brown-wooden-center-table-584399DAY.f1f90fa4.jpg";